import { FC } from 'react';
import { HorizontalPaddingLayout } from '@/HorizontalPaddingLayout';
import { Divider } from '@/components/Divider';
import { AIAnalysis } from './components/AIAnalysis';
import { ConsultationCard } from '@/modules/invest/components/ConsultationCard';
import { FundConsultationFAQ } from './components';

export const ConsultationSection: FC = () => {
  return (
    <div>
      <AIAnalysis />
      <HorizontalPaddingLayout className="py-4">
        <FundConsultationFAQ />
      </HorizontalPaddingLayout>
      <Divider height={8} />
      <HorizontalPaddingLayout className="py-4">
        <ConsultationCard />
      </HorizontalPaddingLayout>
    </div>
  );
};
